module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Ray Namar","short_name":"Ray Namar","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"/opt/build/repo/web/static/img/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"f363c8cc02d16c88f0a77f6b4ad10071"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
